export default "__VITE_ASSET__DOPNVCQ2__"